const initialState = {
    list: [],
    total: "",
    searchKey: "",
  };
  
  export const ManageSquadChallengesListReducer = (state = initialState, action) => {
    switch (action.type) {
      case "MANAGE_ALL_SQUADS_CHALLENGES_RESPONSE":
        return {
           
          ...state,
          list: [...action.data.list],
          total: action.data.total,
        };
  
      default:
        return state;
    }
  };
  
